<template>
  <div class="pages page2 hidden">
    <article>
      <span class="gp-logo"></span>
      <br />
      <span class="page-loading">
        <i></i>
        <i></i>
        <i></i>
        <i></i>
      </span>
      <!-- <div class="text hidden en">
        Google Play is opening automatically,
        <br />if not open,
        <br />click Download to install APK file directally.
        <br />File Safety Checked!
      </div>
      <button class="downloadBtn hidden en" unselectable="on">DOWNLOAD</button> -->
      <div class="text hi" id="p2Lang">
        No Google Play Store?
        <br />Then download apk file here.
        <br />100% free and safe.
        <br />You can watch video nearby,
        <br />Live chat and make friends here.
        <br />
      </div>
      <button class="downloadBtn hi" @click="download">Download</button>
      <button class="go2Gp hi" id="goToGpBtn" @click="openGP">Go to Googleplay</button>
    </article>
  </div>
</template>

<script>
export default {
  methods: {
    download () {
      window._czc.push(['_trackEvent', 'apkClick', 'download']);
      var iframe = document.createElement('iframe')
      iframe.setAttribute('width', '100%')
      iframe.setAttribute('height', '1')
      iframe.style.opacity = 0
      iframe.setAttribute('src', 'http://rec.4funvideo.com/activity/4fun.apk')
      document.querySelector('body').appendChild(iframe)
    },
    openGP () {
      window._czc.push(['_trackEvent', 'goGp', 'goToGpBtn'])
      setTimeout(() => {
        location.href = this.$store.state.buttonUrl
      }, 300);

    }
  }
}
</script>

<style lang="scss" scoped>
.pages {
  height: 100vh;
}
.page2 {
  background: #eeeeee;
}
.hidden {

}
span[id^="cnzz_stat_icon"] {
  display: none;
}
article {
  background-color: #eeeeee;
  font-size: 14px;
  text-align: center;
  padding-top: 40px;
}
.text {
  padding: 1em;
  font-size: 1em;
  color: #454545;
  line-height: 1.5;
}
.gp-logo {
  width: 183px;
  height: 39px;
  background-image: url("http://4funindia.com/img/installActivityMiddlePage/play_prism_hlock_2x.png");
  display: inline-block;
  background-size: 100%;
  background-repeat: no-repeat;
}
.page-loading {
  width: 183px;
  height: 10px;
  display: inline-block;
  text-align: center;
  padding: 50px;
  box-sizing: content-box;
}
@keyframes page-loading {
  0% {
    transform: translate(0px, 0px);
    -webkit-transform: translate(0px, 0px);
  }
  25% {
    transform: translate(0px, 6px);
    -webkit-transform: translate(0px, 6px);
  }
  50% {
    transform: translate(0px, 0px);
    -webkit-transform: translate(0px, 0px);
  }
  100% {
    transform: translate(0px, 0px);
    -webkit-transform: translate(0px, 0px);
  }
}
.page-loading i {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 6px;
  background-color: #f00;
}
.page-loading i:nth-child(1) {
  background-color: #00d3ff;
  animation: page-loading 2s ease-in 0s infinite;
  -webkit-animation: page-loading 2s ease-in 0s infinite;
}
.page-loading i:nth-child(2) {
  background-color: #f73448;
  animation: page-loading 2s ease-in 0.25s infinite;
  -webkit-animation: page-loading 2s ease-in 0.25s infinite;
}
.page-loading i:nth-child(3) {
  background-color: #ffd300;
  animation: page-loading 2s ease-in 0.5s infinite;
  -webkit-animation: page-loading 2s ease-in 0.5s infinite;
}
.page-loading i:nth-child(4) {
  background-color: #04ea74;
  animation: page-loading 2s ease-in 0.75s infinite;
  -webkit-animation: page-loading 2s ease-in 0.75s infinite;
}
.downloadBtn {
  margin-top: 50px;
  display: inline-block;
  width: 200px;
  height: 40px;
  line-height: 32px;
  background-color: #119e5a;
  color: #fff;
  font-size: 16px;
  border: 0px solid #fff;
  border-radius: 2px;
  position: relative;
  outline: none;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  border: 2px solid #119e5a;
}
.go2Gp {
  margin-top: 20px;
  display: inline-block;
  width: 200px;
  height: 40px;
  line-height: 32px;
  background-color: #119e5a;
  color: #fff;
  font-size: 16px;
  border: 0px solid #fff;
  border-radius: 2px;
  position: relative;
  outline: none;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  border: 2px solid #119e5a;
}
.downloadBtn:active {
  box-shadow: inset 0px 2px 2px rgba(0, 0, 0, 0.15);
}
@keyframes downloading {
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
.downloadBtn.downloading {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  font-size: 0;
  border-top-color: transparent;
  animation: downloading 0.75s linear 0.3s infinite;
  -webkit-animation: downloading 0.75s linear 0.3s infinite;
}
</style>
